import { render, staticRenderFns } from "./DateRender.vue?vue&type=template&id=433d8cac&"
import script from "./DateRender.vue?vue&type=script&lang=ts&"
export * from "./DateRender.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports